// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_BuscaFormasPagtoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento/buscaFormasPagto
 *
 * Returns payment methods as a key-value map for dropdowns. No body required.
 */
import { registerContract } from './validate'

export interface FormasPagamento_BuscaFormasPagtoInput {}

registerContract('FormasPagamento_BuscaFormasPagtoInput', {})
